import { TASK_UPDATED, TASK_DISMISSED, SET_TASKS, SHOW_NOTIFICATION_FEEDBACK } from './reduxConstants';
import { Notification } from 'src/@types/manage_data';

export const taskUpdated = (id: string, data: Notification) => ({
	type: TASK_UPDATED,
	payload: { id, data },
});

export const setTasks = (tasks: Record<string, Notification>) => ({
	type: SET_TASKS,
	payload: tasks,
});

export const taskDismissed = (id: string) => ({
	type: TASK_DISMISSED,
	payload: id,
});

export const set_notification_feedback = (visible: boolean, x: number | string = 0, y: number | string = 0) => ({
	type: SHOW_NOTIFICATION_FEEDBACK,
	payload: { visible, x, y },
});
